"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorPremiumWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorMtaPremiumWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorMtaPremiumWordingGenerator");
var AnnualMotorPremiumWidget = exports.AnnualMotorPremiumWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorPremiumWidget, _super);
    function AnnualMotorPremiumWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            policies: []
        };
        return _this;
    }
    AnnualMotorPremiumWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies(services_1.ProductsEnum.WOLF_MOTOR).subscribe(function (policies) {
            _this.setState({
                policies: policies
            });
        });
    };
    AnnualMotorPremiumWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderOutputPanel()));
    };
    AnnualMotorPremiumWidget.prototype.renderOutputPanel = function () {
        var _a;
        var interaction = this.props.engine.getInteraction();
        var additionalPremium = interaction.factors.additionalPremium;
        var returnPremium = interaction.factors.returnPremium;
        var paymentRequired = additionalPremium > 0;
        var refundRequired = returnPremium > 0;
        var price = paymentRequired
            ? (0, commonFunctions_1.getAmountToDisplay)(additionalPremium)
            : (0, commonFunctions_1.getAmountToDisplay)(returnPremium);
        var showSummaryPageWording = this.getSetting("showSummaryPageWording") === "true";
        var mtaPremiumWording = AnnualMotorMtaPremiumWordingGenerator_1.AnnualMotorMtaPremiumWordingGenerator.generateMtaPremiumWording(interaction, this.state.policies, price, showSummaryPageWording);
        var renewalDecline = interaction.uistate.declineRenewal;
        var tierChangeWording = (0, commonFunctions_1.getTierChangeWording)(interaction);
        if (mtaPremiumWording.isGenericModalBodyWording) {
            window.sessionStorage.setItem("mtaHeadsUpMessageText", mtaPremiumWording.successModalBodyWording);
        }
        else {
            window.sessionStorage.setItem("mtaSuccessMessageText", mtaPremiumWording.successModalBodyWording);
        }
        var isRenewalProposal = this.props.interaction.status === services_1.POLICY_STATUS_PENDING_RENEWAL_PENDING_UPDATE;
        return (React.createElement("div", { className: "panel text-center mb-4 policy-change-price" },
            renewalDecline && (React.createElement("p", { className: "ml-1 mb-1 warning-banner banner-warn additional-warning margin-top-0 margin-bottom-0" }, "Due to this change, if you continue you won't be able to renew at the end of your policy. You can make this change now (you'll be covered until your policy end date) or cancel the changes to allow the policy to renew.")),
            isRenewalProposal && (React.createElement("div", null,
                React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                    "This means your next year's renewal price will be",
                    " ",
                    (0, commonFunctions_1.getAmountToDisplay)((_a = interaction.factors) === null || _a === void 0 ? void 0 : _a.annualPremium),
                    " ",
                    tierChangeWording),
                React.createElement("p", null, "All figures include Insurance Premium Tax"))),
            !isRenewalProposal && this.getNonRenewalProposalWording(interaction, paymentRequired, refundRequired, mtaPremiumWording, tierChangeWording)));
    };
    AnnualMotorPremiumWidget.prototype.getNonRenewalProposalWording = function (interaction, paymentRequired, refundRequired, mtaPremiumWording, tierChangeWording) {
        var instalmentsNotPaidOff = interaction.factors.premiumType === services_1.PremiumType.monthly && interaction.paymentDetails.instalmentPlan.totalAmount > 0;
        var premiumType = interaction.factors.premiumType;
        var renewalWindow = interaction.uistate.renewalWindow;
        return (React.createElement(React.Fragment, null,
            paymentRequired && (React.createElement(React.Fragment, null,
                mtaPremiumWording.premiumWording,
                renewalWindow && React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                    "This means your next year's renewal price will be",
                    " ",
                    (0, commonFunctions_1.getAmountToDisplay)(interaction.uistate.totalRenewalAmount),
                    " ",
                    tierChangeWording),
                React.createElement("p", null, "All figures include Insurance Premium Tax"))),
            refundRequired && (React.createElement(React.Fragment, null,
                mtaPremiumWording.premiumWording,
                React.createElement("p", null, this.getRefundWording(premiumType === services_1.PremiumType.monthly, instalmentsNotPaidOff)),
                renewalWindow && React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                    "This means your next year's renewal price will be",
                    " ",
                    (0, commonFunctions_1.getAmountToDisplay)(interaction.uistate.totalRenewalAmount),
                    " ",
                    tierChangeWording))),
            !refundRequired && !paymentRequired && (React.createElement("p", null,
                "Great news! There is no extra cost for the change you made! ",
                tierChangeWording))));
    };
    AnnualMotorPremiumWidget.prototype.getRefundWording = function (isMonthly, instalmentsNotPaidOff) {
        var premiumWording = "";
        if (isMonthly) {
            premiumWording = 'You will receive a pro rata refund for changing your car policy.';
            if (instalmentsNotPaidOff) {
                premiumWording += ' The amount will be deducted from the outstanding balance and spread evenly over the remaining monthly payments.';
            }
        }
        else {
            premiumWording = 'You will receive a pro rata refund for changing your car policy. ' +
                'The refund excludes the cost of your cover prior to the change date.';
        }
        return premiumWording;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorPremiumWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorPremiumWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualMotorPremiumWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorPremiumWidget.js
// module id = 3217
// module chunks = 0